export const apiPath = '/v2/type_polygraphs';
const actionType = 'POLYGRAPHS';

export const bulkActionType = `${actionType}_BULK`;

export default actionType;
